const classNameVerticalBidirectional = "vertical-bidirectional";
const classNameTopToBottom = "top-to-bottom";
const classNameBottomToTop = "bottom-to-top";
const classNameLeftToRight = "left-to-right";
const classNameRightToLef = "right-to-left";
const classNameFadeIn = "fade-in"
const classNameRepeat = "repeat"

let playedAnimationElements = [];

//Observers declarations

const observerTopToBottomFadeInRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animation.play();
    }
    else{
      animationanim.reverse();
    }
  });
},{threshold :0});
const observerTopToBottomFadeIn = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animation.play();
      playedAnimationElements.push(entry.target);
    }
  });
},{threshold :0});

const observerTopToBottomRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animation.play();
    }
    else{
      animation.reverse();
    }
  });
},{threshold :0});
const observerTopToBottom = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animation.play();
      playedAnimationElements.push(entry.target);
    }
  });
},{threshold :0});

const observerBottomToTopFadeInRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animation.play();
    }
    else{
      animation.reverse();
    }
  });
},{threshold :0});
const observerBottomToTopFadeIn = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animation.play();
      playedAnimationElements.push(entry.target);
    }
  });
},{threshold :0});

const observerBottomToTopRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animation.play();
    }
    else{
      animation.reverse();
    }
  });
},{threshold :0});

const observerBottomToTop = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animation = anime({
        targets: entry.target,
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animation.play();
      playedAnimationElements.push(entry.target);
    }
  });
},{threshold :0});

const observerVerticalBidirectionalFadeInRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight;
    //If the element appeared from the bottom
    if (entry.boundingClientRect.top > window.innerHeight / 2){
      animeSlideToRight = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    }
    //If the element came from the top
    else{
      animeSlideToRight = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    }
    if (entry.isIntersecting){
      animeSlideToRight.play();
    }
    else{
      animeSlideToRight.reverse();
    }
  });
},{threshold :0});

const observerVerticalBidirectionalFadeIn = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight;
    //If the element appeared from the bottom
    if (entry.boundingClientRect.top > window.innerHeight / 2){
      animeSlideToRight = anime({
        targets: entry.target,
        autoplay:false,
        opacity: [0, 1],
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    }
    //If the element came from the top
    else{
      animeSlideToRight = anime({
        targets: entry.target,
        autoplay:false,
        opacity: [0, 1],
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    }
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animeSlideToRight.play();
      playedAnimationElements.push(entry.target);
    }
    else{
      entry.target.style.opacity = "1";
      entry.target.style.transform = "";
    }
  });
},{threshold :0});

const observerVerticalBidirectionalRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight;
    if (entry.boundingClientRect.top > 0){
      animeSlideToRight = anime({
        targets: entry.target,
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    }
    else{
      animeSlideToRight = anime({
        targets: entry.target,
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    }
    if (entry.isIntersecting){
      animeSlideToRight.play();
    }
    else{
      animeSlideToRight.reverse();
    }
  });
},{threshold :0});

const observerVerticalBidirectional = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight;
    if (entry.boundingClientRect.top > 0){
      animeSlideToRight = anime({
        targets: entry.target,
        translateY: [50,0],
        duration:500,
        easing: 'linear'
      });
    }
    else{
      animeSlideToRight = anime({
        targets: entry.target,
        translateY: [-50,0],
        duration:500,
        easing: 'linear'
      });
    }
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animeSlideToRight.play();
      playedAnimationElements.push(entry.target);
    }
    else{
      entry.target.style.opacity = "1";
      entry.target.style.transform = "";
    }
  });
},{threshold :0});

const observerLeftToRightFadeInRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateX: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animeSlideToRight.play();
    }
    else{
      animeSlideToRight.reverse();
    }
  });
},{threshold :0});

const observerLeftToRightFadeIn = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateX: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animeSlideToRight.play();
      playedAnimationElements.push(entry.target);
    }
    else{
      entry.target.style.opacity = "1";
      entry.target.style.transform = "";
    }
  });
},{threshold :0});

const observerLeftToRightRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        translateX: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animeSlideToRight.play();
    }
    else{
      animeSlideToRight.reverse();
    }
  });
},{threshold :0});

const observerLeftToRight = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        translateX: [-50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animeSlideToRight.play();
      playedAnimationElements.push(entry.target);
    }
    else{
      entry.target.style.opacity = "1";
      entry.target.style.transform = "";
    }
  });
},{threshold :0});

const observerRightToLeftFadeInRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateX: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animeSlideToRight.play();
    }
    else{
      animeSlideToRight.reverse();
    }
  });
},{threshold :0});

const observerRightToLeftFadeIn = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        opacity: [0, 1],
        translateX: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animeSlideToRight.play();
      playedAnimationElements.push(entry.target);
    }
    else{
      entry.target.style.opacity = "1";
      entry.target.style.transform = "";
    }
  });
},{threshold :0});

const observerRightToLeftRepeat = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        translateX: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting){
      animeSlideToRight.play();
    }
    else{
      animeSlideToRight.reverse();
    }
  });
},{threshold :0});

const observerRightToLeft = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    //Animations declarations
    let animeSlideToRight = anime({
        targets: entry.target,
        translateX: [50,0],
        duration:500,
        easing: 'linear'
      });
    if (entry.isIntersecting && !playedAnimationElements.includes(entry.target)){
      animeSlideToRight.play();
      playedAnimationElements.push(entry.target);
    }
    else{
      entry.target.style.opacity = "1";
      entry.target.style.transform = "";
    }
  });
},{threshold :0});

document.addEventListener("DOMContentLoaded", (event) => {  
  //Top to bottom fade in
  Array.from(document.querySelectorAll("." + classNameTopToBottom + "." + classNameFadeIn)).forEach(el => {
    observerTopToBottomFadeIn.observe(el);
  })
  //Top to bottom  fade in repeat
  Array.from(document.querySelectorAll("." + classNameTopToBottom + "." + classNameFadeIn + "." + classNameRepeat)).forEach(el => {
    observerTopToBottomFadeInRepeat.observe(el);
  })
  //Top to bottom  no fade
  Array.from(document.querySelectorAll("." + classNameTopToBottom + ":not(." + classNameFadeIn + ")")).forEach(el => {
    observerTopToBottom.observe(el);
  })
  //Top to bottom  no fade repeat
  Array.from(document.querySelectorAll("." + classNameTopToBottom + ":not(." + classNameFadeIn + ")" + "." + classNameRepeat)).forEach(el => {
    observerTopToBottomRepeat.observe(el);
  })
  //Bottom to top fade in
  Array.from(document.querySelectorAll("." + classNameBottomToTop + "." + classNameFadeIn)).forEach(el => {
    observerBottomToTopFadeIn.observe(el);
  })
  //Bottom to top  fade in repeat
  Array.from(document.querySelectorAll("." + classNameBottomToTop + "." + classNameFadeIn + "." + classNameRepeat)).forEach(el => {
    observerBottomToTopFadeInRepeat.observe(el);
  })
  //Bottom to top  no fade
  Array.from(document.querySelectorAll("." + classNameBottomToTop + ":not(." + classNameFadeIn + ")")).forEach(el => {
    observerBottomToTop.observe(el);
  })
  //Bottom to top  no fade repeat
  Array.from(document.querySelectorAll("." + classNameBottomToTop + ":not(." + classNameFadeIn + ")" + "." + classNameRepeat)).forEach(el => {
    observerBottomToTopRepeat.observe(el);
  })
  //Vertical bidirectional fade in
  Array.from(document.querySelectorAll("." + classNameVerticalBidirectional + "." + classNameFadeIn)).forEach(el => {
    observerVerticalBidirectionalFadeIn.observe(el);
  })
  //Vertical bidirectional fade in repeat
  Array.from(document.querySelectorAll("." + classNameVerticalBidirectional + "." + classNameFadeIn + "." + classNameRepeat)).forEach(el => {
    observerVerticalBidirectionalFadeInRepeat.observe(el);
  })
  //Vertical bidirectional no fade
  Array.from(document.querySelectorAll("." + classNameVerticalBidirectional + ":not(." + classNameFadeIn + ")")).forEach(el => {
    observerVerticalBidirectional.observe(el);
  })
  //Vertical bidirectional no fade repeat
  Array.from(document.querySelectorAll("." + classNameVerticalBidirectional + ":not(." + classNameFadeIn + ")" + "." + classNameRepeat)).forEach(el => {
    observerVerticalBidirectionalRepeat.observe(el);
  })
  //Left to right fade in
  Array.from(document.querySelectorAll("." + classNameLeftToRight + "." + classNameFadeIn)).forEach(el => {
    observerLeftToRightFadeIn.observe(el);
  })
  //Left to right fade in repeat
  Array.from(document.querySelectorAll("." + classNameLeftToRight + "." + classNameFadeIn + "." + classNameRepeat)).forEach(el => {
    observerLeftToRightFadeInRepeat.observe(el);
  })
  //Left to right no fade
  Array.from(document.querySelectorAll("." + classNameLeftToRight + ":not(." + classNameFadeIn + ")")).forEach(el => {
    observerLeftToRight.observe(el);
  })
  //Left to right no fade repeat
  Array.from(document.querySelectorAll("." + classNameLeftToRight + ":not(." + classNameFadeIn + ")" + "." + classNameRepeat)).forEach(el => {
    observerLeftToRightRepeat.observe(el);
  })
    //Right to left fade in
  Array.from(document.querySelectorAll("." + classNameRightToLef + "." + classNameFadeIn)).forEach(el => {
    observerRightToLeftFadeIn.observe(el);
  })
    //Right to left fade in repeat
  Array.from(document.querySelectorAll("." + classNameRightToLef + "." + classNameFadeIn + "." + classNameRepeat)).forEach(el => {
    observerRightToLeftFadeInRepeat.observe(el);
  })
  //Right to left no fade
  Array.from(document.querySelectorAll("." + classNameRightToLef + ":not(." + classNameFadeIn + ")")).forEach(el => {
    observerRightToLeft.observe(el);
  })
  //Right to left no fade repeat
  Array.from(document.querySelectorAll("." + classNameRightToLef + ":not(." + classNameFadeIn + ")" + "." + classNameRepeat)).forEach(el => {
    observerRightToLeftRepeat.observe(el);
  })
});